import { Component, OnDestroy, OnInit } from "@angular/core";
import { getApp } from "../../app";
@Component({
  selector: "app-oc-comment",
  templateUrl: "./OC-comment.component.html",
  styleUrls: ["./OC-comment.component.scss"],
})
export class OCCommentComponent implements OnInit, OnDestroy {
  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  async ngOnInit() {}

  autoGrow(textarea: HTMLTextAreaElement) {
    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 150) + "px";
  }

  sendComment(textarea: HTMLTextAreaElement) {
    this.app.OCComment.saveComment();
    textarea.style.height = "auto";
  }

  ngOnDestroy() {}
}
